// const handymans = require("./images/handymans.png")
const VIDEO_PATH = require("./images/handyman_laborer.mp4");

const CTA = () => {
  return (
    <section className="bg-white py-10">
      <div className="max-w-screen-xl mx-auto px-4  gap-x-12 justify-between md:flex md:px-8">
        <div className="flex justify-center">
          {/* <img src={handymans} className="w-[250px] h-[250px]" /> */}
          <video
            width="750"
            height="500"
            controls
            autoPlay
            muted
            loop
            className="rounded-2xl shadow-xl"
          >
            <source src={VIDEO_PATH} type="video/mp4" />
          </video>
        </div>
        <div className="max-w-xl mt-2">
          <h3 className="text-gray-700 text-3xl font-extrabold sm:text-4xl">
            Find temporary skilled handyman fast
          </h3>
          <p className="mt-3 text-gray-500">
            Our platform helps you find and hire skilled handymans in appliance
            repair, landscaping, clearning, and more. Find your next skilled
            laborer by creating a free account.
          </p>
          <h2 className="text-3xl font-extrabold text-red-500">
            Easy steps
          </h2>
          <ul className="ml-4 text-gray-600 list-disc my-3 font-semibold">
            <li>Fill out the form</li>
            <li>Wait for 5 minutes</li>
            <li>Get call from us!</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CTA;
